import { Divider } from '../Divider';
import { DividerSlot, RailDividerRule } from './SideNavDivider.styles';
import { useSideNavExpanded } from './SideNavExpandedContext';

export interface SideNavDividerProps {
  readonly light?: boolean;
}

export function SideNavDivider({ light = true }: SideNavDividerProps) {
  const expanded = useSideNavExpanded();

  return (
    <DividerSlot>
      {expanded ? (
        <Divider fullWidth light={light} noMargin />
      ) : (
        <RailDividerRule light={light} />
      )}
    </DividerSlot>
  );
}
